import React from "react";

type Props = { className?: string; size?: number };

const AppsIcon: React.FC<Props> = ({ className, size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <rect x={2.5} y={2.5} width={6} height={6} rx={1.5} stroke="#9F9FA6" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    <rect x={11.5} y={2.5} width={6} height={6} rx={1.5} stroke="#9F9FA6" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    <rect x={2.5} y={11.5} width={6} height={6} rx={1.5} stroke="#9F9FA6" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    <rect x={11.5} y={11.5} width={6} height={6} rx={1.5} stroke="#9F9FA6" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default AppsIcon;
